// extracted by mini-css-extract-plugin
export default {"sentryFallbackPage":"SentryFallbackPage_sentryFallbackPage__EyfIS"};